/*
 * The Evidite logotype: EVIDITE set in Tenon, the same treatment the account
 * portal uses. It is black or white only, so colour comes from its ground in
 * CSS. The text reads "Evidite" to assistive technology; the capitals are
 * styling.
 */
export function Wordmark() {
  return <span className="wordmark">Evidite</span>;
}
